import { createBrowserHistory } from 'history'
import React from 'react'
import { Link as RouterLink } from 'react-router-dom'

export const history = createBrowserHistory()

export const WrapperLink = React.forwardRef((props, ref) => (
  <RouterLink innerRef={ref} {...props} />
))
